<template>
  <v-data-table
    v-if="hasAccess"
    :headers="headers"
    :items="tableData"
    :items-per-page="100"
    sort-by="percent"
    hide-default-footer
    class="elevation-1"
  >
    <template v-slot:item.percent="{ item }">
      <v-chip
        :color="getColor(item.percent)"
        dark
      >
        {{ item.percent }}%
      </v-chip>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        v-if="item.percent <= 10"
        color="primary"
        @click="reset(item)"
      >
        {{ $vuetify.lang.t('$vuetify.reset') }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import apiUtil from '../utils/ApiUtil';
import { Class as PollerUtil } from '../utils/PollerUtil';

export default {
  data() {
    return {
      permissionsKey: 6,
      pollerUtil: new PollerUtil(),
      data: [],
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
    tableData() {
      const result = [];
      for (const item of this.data) {
        item.percent = (100 * item.current / item.initial).toFixed(2);
        result.push(item);
      }
      return result;
    },
    headers() {
      return [
        { text: this.$vuetify.lang.t('$vuetify.machine'), value: 'machineDisplayName' },
        { text: this.$vuetify.lang.t('$vuetify.frameSite'), value: 'frame_site' },
        { text: this.$vuetify.lang.t('$vuetify.frameDepth'), value: 'frame_depth' },
        { text: this.$vuetify.lang.t('$vuetify.frameColumn'), value: 'frame_col' },
        { text: this.$vuetify.lang.t('$vuetify.frameRow'), value: 'frame_row' },
        { text: this.$vuetify.lang.t('$vuetify.factor'), value: 'factor' },
        { text: this.$vuetify.lang.t('$vuetify.article'), value: 'article' },
        { text: this.$vuetify.lang.t('$vuetify.current'), value: 'current' },
        { text: this.$vuetify.lang.t('$vuetify.percent'), value: 'percent' },
        { text: this.$vuetify.lang.t('$vuetify.actions'), value: 'action', sortable: false },
      ];
    },
  },
  async created() {
    await this.refresh();

    this.pollerUtil.interval(1000).exec(
      async () => {
        await this.refresh();
      },
    );
  },
  async destroyed() {
    this.pollerUtil.end();
  },

  methods: {
    async refresh() {
      const response = await apiUtil.getAllWeavingMachine();
      this.data = response;
    },
    async reset(item) {
      const currentItem = item;
      currentItem.current = item.initial;
      await apiUtil.saveWeavingMachine(currentItem);
    },
    getColor(data) {
      if (data <= 10) return 'red';
      if (data <= 50) return 'orange';
      return 'green';
    },
  },
};
</script>
